var exports = {
  "k": "xa15a2ab7--d7efea--container",
  "n": "xa15a2ab7--d7efea--buttons-wrap",
};

module.exports = exports;
